export default function ServiceArea() {
  const areas = [
    'Ravenna Centro',
    'Faenza',
    'Cervia',
    'Lugo',
    'Russi',
    'E dintorni'
  ];

  return (
    <section id="service-area" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
          {/* Content Side */}
          <div className="lg:col-span-2">
            <div className="w-20 h-20 flex items-center justify-center rounded-full bg-gradient-to-br from-[#0066CC] to-[#00A3E0] mb-6">
              <i className="ri-map-pin-fill text-white text-4xl"></i>
            </div>

            <h2 className="text-[#1A2B4A] font-bold text-4xl mb-6">
              Area di Servizio
            </h2>

            <p className="text-gray-600 text-lg leading-relaxed mb-8">
              Serviamo Ravenna e tutti i comuni limitrofi con interventi rapidi e professionali
            </p>

            {/* Areas List */}
            <div className="space-y-3 mb-8">
              {areas.map((area, index) => (
                <div key={index} className="flex items-center gap-3">
                  <div className="w-6 h-6 flex items-center justify-center rounded-full bg-[#00A3E0]/10">
                    <i className="ri-check-line text-[#00A3E0] text-sm"></i>
                  </div>
                  <span className="text-[#1A2B4A] font-medium">{area}</span>
                </div>
              ))}
            </div>

            {/* Badge */}
            <div className="inline-flex items-center gap-2 bg-[#FF6B35] text-white px-6 py-3 rounded-full font-bold shadow-lg">
              <i className="ri-time-line text-xl"></i>
              Intervento Rapido 24/7
            </div>
          </div>

          {/* Map Side */}
          <div className="lg:col-span-3">
            <div className="w-full h-[500px] rounded-3xl overflow-hidden shadow-2xl">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2868.8!2d12.2035!3d44.4184!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x132ca3f0e0e0e0e1%3A0x0!2sVia%20Faentina%2C%2048123%20Ravenna%20RA!5e0!3m2!1sit!2sit!4v1234567890"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Mappa Ravenna"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}